import React, { useState, useEffect } from 'react';
import { Popup, Input, Checkbox, Button, Icon } from 'semantic-ui-react';

// ...
const PopupFiltro = ({ atributosLocais, onConfirm }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItems, setFilteredItems] = useState(atributosLocais);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const filtered = atributosLocais.filter(item =>
            item.tecafabricante.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredItems(filtered);
    }, [searchTerm, atributosLocais]);

    const handleSelectAllChange = (_, data) => {
        setSelectAll(data.checked);
        if (data.checked) {
            const filteredIds = filteredItems.map(item => item.tecafabricante);
            setSelectedItems(filteredIds);
            console.log('itens filtrados ->', filteredIds)
        } else {
            setSelectedItems([]);
        }
    };

    const handleCheckboxChange = (valor, checked) => {
        if (checked) {
            setSelectedItems(prev => [...prev, valor]);
        } else {
            setSelectedItems(prev => prev.filter(item => item !== valor));
            setSelectAll(false);
        }
    };

    const handleConfirm = () => {
        console.log('Itens selecionados:', selectedItems);
        if (onConfirm) onConfirm(selectedItems); // ✅ envia pro componente pai
        setOpen(false);
    };

    const handleCancel = () => {
        setSelectedItems([]);
        setSelectAll(false);
        setSearchTerm('');
        setFilteredItems(atributosLocais);
        setOpen(false);
    };

    useEffect(() => {
        const allFilteredSelected = filteredItems.length > 0 && filteredItems.every(item =>
            selectedItems.includes(item.tecafabricante)
        );
        setSelectAll(allFilteredSelected);
    }, [selectedItems, filteredItems]);

    return (
        <Popup
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            on={'click'}
            content={
                <div style={{ width: '250px' }}>
                    <p>Pesquise por valores dos atributos:</p>
                    <Input
                        placeholder='Pesquisar itens...'
                        style={{ width: '100%' }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <hr />
                    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <Checkbox
                            label='Todos'
                            checked={selectAll}
                            onChange={handleSelectAllChange}
                        />
                    </div>

                    <div
                        style={{
                            border: '1px solid #CACBCD',
                            height: '200px',
                            padding: '5px',
                            margin: '0px -5px',
                            borderRadius: '4px',
                            overflowY: 'auto'
                        }}
                    >
                        {filteredItems.length > 0 ? (
                            filteredItems.map((item, index) => (
                                <Checkbox
                                    key={index}
                                    style={{ display: 'block', margin: '5px' }}
                                    label={item.tecafabricante}
                                    checked={selectedItems.includes(item.tecafabricante)}
                                    onChange={(e, data) =>
                                        handleCheckboxChange(item.tecafabricante, data.checked)
                                    }
                                />
                            ))
                        ) : (
                            <p style={{ textAlign: 'center', color: '#999', marginTop: '20px' }}>
                                Nenhum item encontrado
                            </p>
                        )}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            marginTop: '10px',
                            width: '100%',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Button color='blue' onClick={handleConfirm}>
                            OK
                        </Button>
                        <Button onClick={handleCancel}>
                            Cancelar
                        </Button>
                    </div>
                </div>
            }
            position='bottom center'
            trigger={
                <Button
                    style={{
                        backgroundColor: '#F2F5F8',
                        color: '#102E3E',
                        marginRight: '10px'
                    }}
                    onClick={() => setOpen(!open)}
                >
                    <Icon name='filter' />
                    Filtro
                </Button>
            }
        />
    );
};

export default PopupFiltro;

